import type { JSX } from 'react';
import { useAuthStore } from '@client/stores/auth';

// Shown app-wide when the business is in grace period. Read-only mode is enforced server-side
// (Capability.SaveEstimate gate); this banner exists to set user expectation.
export function GraceBanner(): JSX.Element | null {
  const me = useAuthStore((s) => s.me);
  if (!me?.plan) return null;
  if (me.plan.state !== 'grace') return null;
  const graceUntil = me.plan.graceUntil;
  const daysLeft = graceUntil
    ? Math.max(0, Math.ceil((graceUntil - Date.now()) / (24 * 60 * 60 * 1000)))
    : null;
  return (
    <div
      role="alert"
      className="bg-amber-100 px-4 py-2 text-center text-sm text-amber-900 dark:bg-amber-950 dark:text-amber-100"
    >
      Your Pro plan has expired. {daysLeft !== null ? `Grace ends in ${daysLeft} day${daysLeft === 1 ? '' : 's'}.` : 'Grace active.'}{' '}
      Renew to keep saving estimates.
    </div>
  );
}
